module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-26.a799b8f1.png";